var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.605 7.866L4.922 38.38c-.694 1.126.173 2.6 1.473 2.6h35.28c1.3 0 2.167-1.387 1.474-2.6L25.552 7.866c-.607-1.127-2.34-1.127-2.947 0z",
    fill: "#ff612b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.245 30.49h-4.334V18.702c0-.867.52-1.648 1.3-1.994 1.474-.607 3.035.433 3.035 1.994V30.49zm-2.167 2.167c-1.3 0-2.427 1.127-2.427 2.428 0 1.3 1.127 2.427 2.427 2.427 1.387 0 2.428-1.04 2.428-2.427 0-1.3-1.127-2.428-2.428-2.428z",
    fill: "#002677"
  })));
}
export default SvgAlert;